export const getRegion = (colorsTheme = null) => {
  // let region = localStorage.getItem("region"); // dev method

  let region = getDefinedRegion();

  if (
    window.location.href.includes('member/') ||
    window.location.href.includes('SeasonPassMember/') ||
    window.location.href.includes('share-ticket') ||
    window.location.href.includes('partizan.basketball')
  ) {
    region = 'partizan';
  }
  localStorage.setItem("region", region);

  const url = window.location.origin;
  const defaultData = {
    url,
    theme: "sixtix",
    title: "SixTix",
    defaultTimeZone: "Europe/Belgrade",
    currency: "RSD",
    terms: `
      <p class="terms-title">OPŠTI USLOVI KORIŠĆENJA</p>
      <p class="sub-title"><strong>PRODAVAC</strong></p>
      
      <ul class="terms-list">
      <li>SIXTIX DOO</li>
      <li>Humska 1</li>
      <li>7990 Ostale usluge rezervacija i srodne aktivnosti</li>
      <li>11000 Beograd</li>
      <li>Maticni broj firme: 21940291</li>
      <li>PIB: 113886255</li>
      <li><a href="https://www.sixtix.com/ ">https://www.sixtix.com/</a></li>
      <li>Phone: +381 69 8017 686</li>
      <li><a href="mailto:support@sixtix.com">support@sixtix.com</a></li>
      </ul>
      
      <h2>USLOVI KORISCENJA SIXTIX ONLINE SERVISA</h2>
      <p>Korišćenje sajta <a href="https://www.sixtix.com/ ">https://www.sixtix.com/</a>, kao i usluge kupovine/prodaje karata online preko sajta sixtix.com (u daljem tekstu: "Servis") podléže ovim Uslovima korišćenja. Ovi Uslovi korišćenja predstavljaju ugovor između SIXTIX DOO (u daljem tekstu "mi", "naš") i posetilaca sajta http://sixtix.com i/ili kupaca karata (u daljem tekstu "vi", "vaš"). Ukoliko ste organizacija koja prodaje karte ili upravlja blagajnama korišćenjem SIXTIX sistema, vaše korišćenje sistema regulisano je Ugovorom sa prodavcem i Opštim uslovima SIXTIX-a.</p>
      
      <h2>SERVIS Dostupnost i cene karata.</h2>
      <p>Organizator samostalno određuje dostupnost broja karata za događaj ili nastup. Cene karata takođe određuje sam organizator.</p>
      
      <h2>KARTE Dostupnost i cene karata.</h2>
      <p>Organizator isključivo odlučuje o dostupnosti i ceni karata.<br /><strong>Izjava o PDV-u</strong><br />PDV je uključen u cenu i nema skrivenih troškova.</p>
      
      <h2>KUPOVINA KARATA</h2>
      <p>Kada kupite kartu putem Servisa, karta će vam biti poslata elektronski putem e-maila po završetku procesa kupovine. Nećete dobiti papirnu kopiju karte, već samo elektronsku verziju.<br /><br /><strong>Zaštita finansijskih transakcija</strong><br />Prilikom unosa podataka o platnoj kartici, poverljive informacije se prenose preko javne mreže u zaštićenom (kriptovanom) obliku putem SSL protokola i PKI sistema. Sigurnost podataka prilikom kupovine garantuje procesor kartica, banka prihvatioc, te se celokupan proces plaćanja odvija na bezbednoj stranici. SIXTIX nikada nema uvid u podatke sa kartice.<br /><br /><strong>Izjava o konverziji</strong><br />Sva plaćanja se vrše u srpskoj valuti (RSD). Iznos koji će biti naplaćen sa vaše kartice se dobija konverzijom iz iznosa u evrima u dinare po kursu Narodne banke Srbije. Prilikom naplate, banka vaše kartice vrši dodatnu konverziju u lokalnu valutu, zbog čega može doći do neznatnog odstupanja u iznosu.</p>
      
      <h2>POVRAT SREDSTAVA</h2>
      <p>Povrat novca za kupljene karte je isključivo u nadležnosti organizatora događaja i može se izvršiti samo preko te organizacije. Ukoliko dođe do preplate ili greške izazvane radom SIXTIX sistema, a kada se takva greška potvrdi, moguć je povrat sredstava na diskreciono pravo SIXTIX-a. U tom slučaju, kontaktirajte nas putem e-maila: <a href="mailto:info@sixtix.com">info@sixtix.com</a>.<br /><br /><strong>Povrat naplaćenih sredstava</strong><br />U slučaju povraćaja robe i povrata sredstava korisniku koji je platio platnom karticom, povraćaj se vrši isključivo putem platnih sistema: DinaCard, Maestro/MasterCard i VISA.</p>
      
      <h2>ŽALBE</h2>
      <p>Žalbe su retke, ali mogu biti pokrenute u slučaju zloupotrebe kartice ili drugih razloga "više sile". Kontaktirajte nas putem e-maila kako bismo vaš problem rešili direktnom komunikacijom u najkraćem mogućem roku.</p>
      
      <h2>KONTAKT SA ORGANIZATOROM</h2>
      <p>Ako imate pitanja za organizatora događaja, kontakt informacije se nalaze u potvrdi o prijemu karata koju vam SIXTIX dostavlja elektronski.</p>
      
      <h2>OTKAZIVANJE PORUDŽBINE</h2>
      <p>Zadržavamo pravo da otkažemo kupovinu karata iz bilo kog razloga, uključujući, ali ne ograničeno na: nepotpune ili netačne informacije o plaćanju, neispravne kartice ili kršenje SIXTIX politike prihvatljivog korišćenja.</p>
      
      <h2>POLITIKA KORIŠĆENJA</h2>
      <p>Korišćenje servisa podléže "politici prihvatljivog korišćenja" SIXTIX-a. Strogo je zabranjena svaka aktivnost koja može naštetiti ugledu, vrednostima ili bezbednosti sistema, uključujući hakerske napade, zloupotrebu pristupa, automatske kupovine putem botova, lažno predstavljanje, objavljivanje uvredljivog sadržaja, kao i povredu autorskih prava. SIXTIX može privremeno ili trajno blokirati pristup korisnicima koji prekrše ovu politiku.</p>
      
      <h2>POLITIKA PRIVATNOSTI</h2>
      <p>Vaše korišćenje servisa podléže i SIXTIX politici privatnosti, koja se povremeno ažurira radi usklađivanja sa propisima. Politika privatnosti se odnosi samo na SIXTIX, ne i na treće strane. SIXTIX prikuplja samo osnovne podatke korisnika, koji su neophodni za poslovanje, i pruža korisnicima mogućnost izbora da li žele da primaju marketinške poruke. Podaci su dostupni samo zaposlenima kojima su potrebni za rad.</p>
      
      <h2>IZJAVE I OGRANIČENJA ODGOVORNOSTI Izjava</h2>
      <p>Sajt <a href="https://www.sixtix.com/ ">https://www.sixtix.com/</a> nije namenjen osobama mlađim od 13 godina. Korišćenjem sajta garantujete da ste stariji od 13 godina i da imate pravo da kupujete karte.<br /><br /><strong>Odricanje od odgovornosti</strong><br />Servis se pruža "takav kakav je", bez garancija, uključujući garancije za prikladnost, tačnost, ili nekršenje prava trećih lica. Ne garantujemo da će servis raditi bez grešaka ili prekida.<br /><br /><strong>Ograničenje odgovornosti</strong><br />Ni u kom slučaju ne snosimo odgovornost za indirektnu, posebnu ili posledičnu štetu nastalu korišćenjem servisa. Ova ograničenja ne važe u slučaju grube nepažnje. Ako zakon nalaže drugačije, primenjivaće se zakonske odredbe.</p>
      
      <h2>OSTALE ODREDBE Izmene</h2>
      <p>SIXTIX zadržava pravo izmene uslova korišćenja, politike prihvatljivog korišćenja i politike privatnosti u bilo kom trenutku.

      <br /><br />
      <strong>Prenos i važenje ugovora</strong>
      <br />
      Ni jedna strana ne može preneti prava iz ovog ugovora bez pisane saglasnosti, osim u slučaju spajanja sa drugim pravnim licem. Ovaj ugovor obavezuje pravne sledbenike ugovornih strana.

      <br /><br />
      <strong>Merodavno pravo - Srbija</strong>
      <br />
      Ovaj ugovor se zaključuje u Srbiji i podleže zakonima Republike Srbije. Svi sporovi biće u nadležnosti sudova u Srbiji.

      <br /><br />
      <strong>Autorska prava</strong>
      <br />
      Ako smatrate da je vaš rad objavljen na SIXTIX sajtu bez dozvole i van granica dozvoljene upotrebe, kontaktirajte nas na <a href="mailto:info@sixtix.com">info@sixtix.com</a>.

      <br /><br />
      <strong>Deljivost</strong>
      <br />
      Ukoliko se neka odredba ovog ugovora pokaže kao nevažeća, ona će biti tumačena u skladu sa svrhom, dok ostale odredbe ostaju na snazi.

      <br /><br />
      <strong>Dodatni pravni dokumenti</strong>
      <br />
      Politika privatnosti (posetioci/korisnici kartica), Ugovor sa prodavcem (organizatori događaja).

      <br /><br />
      <strong>Marketing i saglasnost</strong>
      <br />
      Davanjem e-mail adrese i broja telefona, saglasni ste da vam SIXTIX DOO može slati marketinške poruke u skladu sa GDPR. U svakom trenutku možete povući saglasnost slanjem e-maila na <a href="mailto:info@sixtix.com">info@sixtix.com</a>. Vaši podaci se ne dele sa trećim stranama bez izričite saglasnosti i obrađuju se u skladu sa našom Politikom privatnosti.</p>
    `,
    footer: `
      <li className="sell-footer__contacts-item">SIXTIX d.o.o. Beograd</li>
      <li className="sell-footer__contacts-item">MB: 21940291</li>
      <li className="sell-footer__contacts-item">Humska 1</li>
      <li className="sell-footer__contacts-item">PIB: 113886255</li>
      <li className="sell-footer__contacts-item">11 000 Beograd</li>
      <li className="sell-footer__contacts-item">
        <a
          href="mailto:info@sixtix.com"
          rel="noopener noreferrer"
          target="_blank"
          style="color: ${colorsTheme && colorsTheme.primaryColor}"
        >
          info@sixtix.com
        </a>
      </li>
      <li className="sell-footer__contacts-item">
        +381 69 8017 686
      </li>
      <li className="sell-footer__contacts-item">
        <a
          href="https://sixtix.rs/"
          rel="noopener noreferrer"
          target="_blank"
          style="color: ${colorsTheme && colorsTheme.primaryColor}"
        >
          www.sixtix.rs
        </a>
      </li>
    `,
    termsLink: 'https://sixtix.rs/terms-of-service',
    policyLink: 'https://sixtix.rs/privacy-policy-and-cookies',
  }

  switch (region) { // host for prod
    case "fanceetickets":
      return {
        ...defaultData,
        theme: "fanceetickets",
        title: "FanceeTickets",
        terms: `
          <p className="terms-title">TERMS AND CONDITIONS</p>
          <p className="sub-title">
            <strong>SELLER</strong>
          </p>
          <ul className="terms-list">
            <li>WE ARE FANCEE DOO</li>
            <li>Humska 1</li>
            <li>7990 Other reservation services and related activities</li>
            <li>11000 Belgrade</li>
            <li>Company Registration Number: 21940291</li>
            <li>Tax Identification Number: 113886255</li>
            <li>
              <a
                href="https://fanceetickets.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.fanceetickets.com
              </a>
            </li>
            <li>Phone: +381 69 8017 686</li>
            <li>
              <a
                href="mailto:info@fanceetickets.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                info@fanceetickets.com
              </a>
            </li>
          </ul>
          <h2>TERMS OF USE OF THE WE ARE FANCEE ONLINE SERVICE</h2>
          <p>
            Your use of the fanceetickets.com website, as well as the service of purchasing/selling 
            tickets online at fanceetickets.com (hereinafter referred to as the "Service"), is 
            subject to these Terms of Use. These Terms of Use constitute an agreement between 
            We Are Fancee Ltd. Belgrade (hereinafter "WAF," "Our") and visitors of the 
            fanceetickets.com website and/or ticket buyers (hereinafter "You," "Your"). If you 
            are an organization selling tickets or managing ticket offices using the WE ARE FANCEE 
            ticket office management system, your use and operation of that system are governed 
            by the WE ARE FANCEE Seller Agreement and Terms of Service.
          </p>

          <h2>SERVICE</h2>
          <p>
            Availability and ticket prices. The organization solely determines the availability of the 
            number of tickets for events or performances. The ticket prices are determined by the 
            organization selling the tickets.
          </p>

          <h2>TICKETS</h2>
          <p>
            Availability and ticket prices. The organization solely determines the availability of the 
            number of tickets for events or performances. The ticket prices are determined by the 
            organization selling the tickets.
            <br/>
            VAT Statement
            <br/>
            VAT included in the price and no hidden costs
          </p>

          <h2>TICKET PURCHASE</h2>
          <p>
            If you purchase tickets from the seller through the Service, the ticket will be sent to you via 
            email after the ticket purchase process is completed. You will not receive a paper copy of the ticket 
            from WAF, only an electronic copy of the purchased ticket.
            <br/>
            Financial Transaction Data Protection
            <br/>
            When entering credit card data, confidential information is transmitted over a public network in a 
            protected (encrypted) form using SSL protocol and PKI system, as the most current cryptographic 
            technology. The security of data during purchase is guaranteed by the card processor, the Acquirer 
            Bank, so the entire payment process is carried out on a secure page, whose processor is the Bank. 
            At no time are credit card data available to our system.
            <br/>
            Conversion Statement
            <br/>
            All payments will be effected in Serbian currency – dinar (RSD). The amount your credit
            card account will be charged for is obtained through the conversion of the price in Euro
            into Serbian dinar according to the current exchange rate of the Serbian National Bank.
            When charging your credit card, the same amount is converted into your local currency
            according to the exchange rate of credit card associations. As a result of this conversion
            there is a possibility of a slight difference from the original price stated in our web site’.
          </p>

          <h2>REFUND OF FUNDS</h2>
          <p>
            The refund of previously purchased tickets is at the discretion of the selling organization 
            (we do not have the discretionary right to refund money) and can only be done through that 
            organization. In case of overpayment or other errors caused by the WAF service itself and when 
            these errors are confirmed, a refund may be made at WAFs discretion. In that case, contact We 
            Are Fancee support via
            {" "}
            <a href="mailto:info@fanceetickets.com">info@fanceetickets.com</a>.
            <br/>
            Refund of Charged Funds
            <br/>
            In the event of returning goods and refunding funds to a customer who previously paid with any of 
            the payment cards, either partially or in full, regardless of the reason for the return, WAF 
            is obliged to make the refund exclusively through American Express (AmEx), DinaCard, Maestro/MasterCard, 
            and VISA payment methods, meaning that the Electronic Money Institution, upon the merchants request, 
            will refund the funds to the cardholders account.
            <br/>
            Complaints are not common and may be initiated in case of card misuse or any other force majeure reasons. 
            Please contact us by email, and we will resolve your complaint through direct communication as soon as possible.
          </p>

          <h2>CONTACT THE SELLING ORGANIZATION</h2>
          <p>
            If you have any questions for the ticket seller (event organizer), you can contact them using the contact 
            information provided in the confirmation of receipt of your ticket, which WAF sends to you electronically.
          </p>

          <h2>ORDER CANCELLATION</h2>
          <p>
            We reserve the right to cancel any ticket purchase for any reason, including but not limited to incomplete 
            or inaccurate payment information, purchasing irregular cards, or any other violation of the WAF Acceptable 
            Use Policy, provisions, and terms USAGE POLICY
            <br/>
            Your use of the service is subject to the "acceptable use policy" established by WAF. The main focus of this 
            policy is not to use our service to commit acts that may be harmful to WAF or undermine WAFs ethical standards, 
            values, and reputation. Malicious actions include intentional misuse of access, granted privileges or licenses, 
            use of copyrighted material, or any infringement of intellectual property, hacking, involvement of third parties, 
            DoS attacks, intentional misuse or misrepresentation of ticket purchases, altering routes, conducting 
            robot-controlled purchases, or impersonating the WAF website. From time to time, our understanding of what is 
            harmful may change as a result of new (technological) developments. Standards and values in using our service reflect 
            social norms and values. Posting offensive images, texts, statements, or defamatory statements do not represent 
            acceptable social norms and moral values, nor do statements lacking artistic, literary, or scientific value. We may, 
            at our discretion, temporarily block your account or completely block access if you violate this WAF "acceptable use" policy.
          </p>
          <h2>PRIVACY POLICY</h2>
          <p>
            Your use of the service is also subject to WAFs privacy policy, which is updated from time to time to 
            comply with current regulations. The Privacy Policy page can be accessed via a link on the WAF websites 
            homepage. Please note that the Privacy Policy applies only to the Service and does not cover third-party 
            websites or services linked through the Service. Additionally, all information you share with the ticket 
            seller through WAF or outside of WAF, such as your name and email address, is subject to that sellers 
            privacy policy
            <br/>
            On behalf of WAF, we commit to maintaining the privacy of all our customers. We only collect necessary, 
            basic customer/user data and data necessary for business and informing users in accordance with good business 
            practices and in order to provide quality service. We give customers the option to choose, including the option 
            to decide whether or not they want to be removed from mailing lists used for marketing campaigns. All customer/user 
            data is strictly kept and available only to employees who need this data to perform their job. All WAF employees 
            and business partners are responsible for adhering to the principles of privacy protection.
          </p>

          <h2>STATEMENTS, DISCLAIMER OF LIABILITY, AND LIMITATION OF LIABILITY</h2>
          <h2>STATEMENT</h2>
          <p>
            The service and website www.fanceetickets.com are not intended for children under the age of 13. 
            By using the Service, you promise that you are over 13 years old and have the authority or appropriate permission 
            to purchase tickets purchased through www.fanceetickets.com
          </p>

          <h2>DISCLAIMER OF LIABILITY</h2>
          <p>
            The WAF service is offered "as is" and we make no warranties, express or implied, including, but not limited to, 
            implied warranties of merchantability, fitness for a particular purpose, non-infringement of intellectual property 
            rights, or implied warranties arising from applicable law. We are not obligated to indemnify or defend you against 
            lawsuits related to intellectual property infringement; and we cannot guarantee that the Service will operate without 
            error or interruption.
          </p>

          <h2>LIMITATION OF LIABILITY</h2>
          <p>
            Under no circumstances will we be liable for any damages, including consequential, indirect, special, incidental, 
            or punitive damages arising out of or in connection with your use of the Service. The limitations of liability in 
            this section do NOT APPLY to liability for negligence, regardless of the form of action, and apply even if we are 
            aware in advance of the possibility of damages and even if such damages were foreseeable. Limitations of liability 
            also apply even if your available legal remedies are inadequate. If applicable law limits the application of the 
            provisions of this section, our liability will still be limited.
          </p>

          <h2>OTHER TERMS</h2>

          <h2>AMENDMENTS</h2>
          <p>
            We may change these Terms and Conditions from time to time by posting an amended version on our website. At any time, 
            we may change the WAF "acceptable use" policy or our privacy policy. We recommend that you periodically review these terms.
          </p>

          <h2>TRANSFER AND DURATION</h2>
          <p>
            Neither party may transfer this Agreement or any of its rights or obligations hereunder without the express written consent 
            of the other, except for the transfer of the Agreement to a legal entity that, as a result of any merger of our company 
            with another, would represent a newly formed legal entity. Except to the extent that transfer is not permitted in the 
            preceding sentence, this Agreement shall be binding upon (and shall inure to the benefit of) the parties respective successors.
          </p>

          <h2>APPLICABLE LAW - SERBIA</h2>
          <p>
            This Agreement is made in the Serbia and shall be governed by Serbian law. The Customer agrees to the exclusive jurisdiction of the courts in Serbia.
          </p>

          <h2>COPYRIGHT</h2>
          <p>
            If you believe that your work is posted on the WAF website in violation of copyright without permission, and exceptions for 
            fair use are not applicable or have been exceeded, you can send an email describing the misuse to {" "}
            <a href="mailto:info@fanceetickets.com">info@fanceetickets.com</a>.
          </p>

          <h2>SEVERABILITY</h2>
          <p>
            To the extent permitted by applicable law, the parties waive all legal provisions that would cause a clause of this agreement 
            to be invalid or otherwise unenforceable in any respect. In the event that any provision of this agreement is nevertheless 
            invalid or otherwise unenforceable, such provision shall be interpreted in a manner that comes as close as possible to the 
            purpose intended by that provision (to the greatest extent permitted by applicable law), while the remaining provisions of 
            this Agreement shall remain in force.
          </p>

          <h2>OTHER LEGAL DOCUMENTS</h2>
          <p>
            Privacy Policy (Visitor/Cardholder) WAF Seller Agreement and Terms of Service (Event Organizers).
          </p>
        `,
      };

    case "sixtix":
      return {
        ...defaultData,
      };

    case "partizan":
      return {
        ...defaultData,
        theme: 'partizan',
        title: "Partizan",
        defaultTimeZone: "Europe/Belgrade",
        currency: "RSD",
        terms: `
          <p class="terms-title">OPŠTI USLOVI KORIŠĆENJA</p>
          <p class="sub-title"><strong>PRODAVAC</strong></p>
          
          <ul class="terms-list">
          <li>Kosarkaski klub Partizan</li>
          <li>Humska 1</li>
          <li>9312 - Delatnost sportskih klubova</li>
          <li>11000 Beograd</li>
          <li>Maticni broj firme: 07051026</li>
          <li>PIB: 101368803</li>
          <li><a href="https://partizan.basketball/ ">https://partizan.basketball/</a></li>
          <li>Phone: +381 66 8551 011</li>
          <li><a href="mailto:tickets@partizan.basketball">tickets@partizan.basketball</a></li>
          </ul>
          
          <h1>Uslovi korišćenja</h1>
          <p>Stupaju na snagu 21.08.2026. godine </p>

          <h2>Uvod</h2>
          <p>Košarkašku klub Partizan, sa sedištem na adresi Humska 1, Savski Venac, Beograd, Republika Srbija, 
matični broj: 07051026, PIB: 101368803, e-mail adresa: <a href="mailto:kkpartizan@partizan.basketball">kkpartizan@partizan.basketball</a>, internet 
sajt: <a href="https://partizan.basketball/ ">https://partizan.pasketball/</a>, čiji su zakonski zastupnici Mlađan Šilobad i Dule Karavesović (u 
daljem tekstu: <b>„Partizan“</b>) preko svoje platforme pruža usluge prodaje ulaznica za sportske događaje 
čiji je organizator. </p>
          <p>Pažljivo pročitajte Uslove korišćenja pre nego što koristite internet sajt Partizana. Posetom i 
korišćenjem internet sajta Partizana na bilo koji način, zapravo sklapate ugovor sa Partizanom i 
obavezujete se da ćete u potpunosti poštovati Uslove korišćenja. Uslovi korišćenja sadrže 
obavezujuće odredbe koje se odnose na način korišćenja kao i prava i obaveze korisnika, uključujući 
ograničenje odgovornosti i pravila za rešavanje sporova. </p>
          <p>Pre kupovine usluge preko ovog internet sajta, potrebno je da se detaljno upoznate sa Uslovima 
korišćenja a kako biste imali na raspolaganju sve neophodne informacije u cilju donošenja odluke. 
Korišćenjem i kupovinom usluge putem ovog internet sajta, saglašavate se sa svim uslovima i 
informacijama koje su prezentovane, te potvrđujete da ste Uslove korišćenja pročitali, razumeli i 
prihvatili u celosti. Uslovima korišćenja regulisani su uslovi kupovine usluge, prava i obaveze kao i 
sva ostala pitanja od značaja za funkcionisanje i obavljanja kupovine putem ovog internet sajta.</p>
          <p>Politika privatnosti Partizana dopunjuje Uslove korišćenja. Pažljivo pročitajte sve informacije i 
proveravajte ažuriranja spomenutih dokumenata. </p>
          
          <br/>

          <h2>Način kupovine</h2>
          <p>Partizan kao organizator sportskih događaja vrši prodaju karata putem interneta preko svog internet 
sajta tako što licu koje se prethodno registruju odnosno uloguju preko internet sajta omogućava 
kupovinu karata (u daljem tekstu: <b>„Kupac“</b>).  </p>
          <p>Ukoliko Kupac kupi kartu, ista će mu biti poslata putem e-mail-a nakon što se završi proces kupovine 
karte. Kupac neće dobiti papirnu kopiju karte od Partizana već samo elektronsku kopiju kupljene 
karte koju može uneti u svoj digitalni novčanik (<b>„Wallet“</b>) na mobilnom telefonu. </p>
          <p>Kupovina ulaznica na internet sajtu Partizana je obavezujuća i Kupac ne može odustati od izvršene 
kupovine u skladu sa članom 36. stav 1. tačke 12 i 13 Zakona o zaštiti potrošača, s obzirom na to da 
Partizan prodajom ulaznica pruža usluge povezane sa aktivnostima koje se odvijaju u tačno određeno 
vreme odnosno u određenom periodu (odnosno za koje postoji konkretni rok ili period izvršenja), kao 
i da je reč o isporuci digitalnog sadržaja u vidu PDF ulaznica ili u vidu elektronske ulaznice na bazi 
NFC tehnologije u digitalnom novčaniku na mobilnom telefonu. U skladu sa propisanim odredbama 
Zakona o zaštiti potrošača, Kupac prihvatanjem Uslova korišćenja izričito izjavljuje da je obavešten 
od strane Partizana da ne može koristiti pravo na odustanak od ugovora na šta Kupac pristaje. </p>

          <br/>

          <h2>Zaštita podataka o finansijskoj transakciji</h2>
          <p>Prilikom unošenja podataka o platnoj kartici Kupca, poverljive informacije se prenose putem javne 
mreže u zaštićenoj odnosno kriptovanoj formi upotrebom savremenih kriptografskih protokola, kao 
trenutno najsavremenije kriptografske tehnologije. Sigurnost podataka prilikom kupovine, garantuje 
procesor platnih kartica odnosno banka preko koje se transakcija vrši te se tako kompletni proces 
naplate obavlja na bezbednoj stranici. Niti jednog trenutka podaci o platnoj kartici Kupca nisu 
dostupni Partizanu. </p>

          <br/>

          <h2>Izjava o konverziji</h2>
          <p>Sva plaćanja biće izvršena u dinarima (RSD) koja je zvanična valuta u Republici Srbiji. Za 
informativni prikaz cena u drugim valutama koristi se kurs Narodne Banke Srbije. Iznos za koji će biti 
zadužena Kupčeva platna kartica biće izražen u lokalnoj valuti Kupca kroz konverziju po kursu koji 
koristi banka preko koje se vrši transakcija. Kao rezultat ove konverzije postoji mogućnost neznatne 
razlike od originalne cene navedene na internet sajtu Partizana i one koju Kupac može videti na 
bankovnom izvodu. </p>

          <br/>

          <h2>Opis usluge i cena</h2>
          <p>Internet sajt Partizana namenjen je između ostalog Kupcima karata za sportske događaje čiji je 
organizator.</p>
<p>O dostupnosti broja ulaznica za sportske događaje kao i ceni karata odlučuje Partizan. </p>

          <br/>

          <h2>Izjava o PDV-u</h2>
          <p>PDV je uračunat u cenu karte i nema skrivenih troškova. </p>

          <br/>

          <h2>Kupčeve obaveze</h2>
          <p>Korišćenjem internet sajta Partizana, Kupac garantujete da ima najmanje 16 (šesnaest) godina starosti 
i da su lični podaci koje pruža tačni i potpuni. Kupac je saglasan da će koristiti internet sajt Partizana 
samo u zakonite svrhe i na način koji ne narušava prava drugih, niti ograničava i sprečava korišćenje 
stranice od strane bilo kog trećeg lica.</p>

          <br/>

          <h2>Zabrana zloupotrebe</h2>
          <p>Kupac odnosno korisnik koji pristupa internet sajtu Partizana je dužan da se uzdržava od svakog 
ponašanja koje može predstavljati zloupotrebu. Postupak Korisnika smatraće se zloupotrebom i/ili 
nedozvoljenom radnjom ukoliko je u suprotnosti sa pozitivnim propisima Republike Srbije, 
savesnošću i/ili dobrim poslovnim običajima. Korisnicima internet sajta Partizana nije dozvoljeno da:</p>
          <p><ul>
            <li>ometaju i/ili onemogućavaju bilo koju funkciju povezanom sa sigurnošću na internet stranici 
i/ili funkcijom koja sprečava i/ili ograničava upotrebu i/ili kopiranje dostupnog sadržaja; </li>
            <li>objavljuju i/ili prenose svaki materijal koji je preteći, klevetnički, nepristojan, uvredljiv, 
pornografski i/ili zlostavljački; </li>
            <li>daju netačne informacije koje se tiču podataka o ličnosti; </li>
            <li>koriste tuđe lične podatke bez saglasnosti tog lica i/ili se lažno predstavljaju da istupaju u ime 
bilo kog trećeg lica; </li>
            <li>se bave bilo kojim nezakonitim i/ili protivpravnim ponašanjem preko internet stranice; </li>
            <li>preduzimaju protivpravne radnje (kao što su sajber napad i sl.) na internet sajtu i/ili u vezi sa 
istom; </li>
            <li>koriste specijalizovane programe radi preuzimanja sadržaja; </li>
            <li>zloupotrebljavaju pravila i uslove kupovine u bilo koje druge svrhe osim u svrhe kupovine 
usluge. </li>
          </ul></p>
          <p>U situacijama u kojima se utvrdi da je porudžbina kreirana sa ciljem zloupotrebe, Partizan zadržava 
pravo da takvu porudžbinu otkaže. U slučaju povrede odredbi Uslova korišćenja, odnosno svakog 
protivpravnog i/ili malicioznog ponašanja na internet sajtu Partizana i/ili u vezi sa istim, Partizan ima 
pravo da preduzme sva pravno dozvoljena sredstva u cilju zaštite svojih prava i interesa. Ukoliko na 
internet sajtu Partizana, Kupac ostavi svoj komentar, recenziju, ocenu usluge, fotografiju, itd, 
prihvatanjem ovih Uslova korišćenja, Kupac je saglasan sa korišćenjem takvog komentara, recenzije, 
ocene usluge, fotografije, itd. u marketinške svrhe od strane Partizana. </p>

          <br/>

          <h2>Nedozvoljene transakcije</h2>
          <p>Partizan se obavezuje da će vršiti prodaju robe i/ili usluga u skladu sa zakonom i propisima Republike 
Srbije. Na internet prodajnom mestu izričito je zabranjeno nuditi robu i/ili usluge iz sledećih 
kategorija: </p>
          <p><ul>
            <li>radioaktivne, otrovne i eksplozivne materije; </li>
            <li>hemijske proizvode štetne za okolinu; </li>
            <li>zaštićene životinjske i biljne vrste; </li>
            <li>ljudske ili životinjske organe;</li>
            <li>opojne droge; </li>
            <li>pornografski materijal;</li>
            <li>lekove kao i druge kategorije propisanih zakonima i drugim propisima. </li>
          </ul></p>
          <p>Na internet sajtu Partizana moguće je obaviti kupovinu u svojstvu fizičkog lica, preduzetnika i 
pravnog lica. Ukoliko se za kupovinu koristi platna kartica privrednog društva odnosno preduzetnika, 
u tom slučaju ni Partizan ni banka preko koje se vrši transakcija ne odgovaraju za poreske kao i druge 
zakonske obaveze koje prate platnu transakciju i osnovni pravni posao na osnovu kojeg je transakcija 
izvršena, niti bilo koje druge poreze koji mogu nastati prilikom kupovine usluge. U procesu 
obavljanja kupovine, Kupac izjavljuje da je upoznat i saglasan sa Uslovima korišćenja i Politikom 
privatnosti. Informacije objavljene na internet sajtu u vezi sa uslugama koje se nude na prodaju ne 
predstavljaju ponudu za zaključenje ugovora. Ugovor o kupovini usluge se smatra zaključenim onog 
momenta kada Kupcu putem e-mail-a bude dostavljena potvrda porudžbine i račun od strane 
Partizana. </p>

          <br/>

          <h2>Zaštita podataka o ličnosti</h2>
          <p>Podatak o ličnosti u smislu Zakona o zaštiti podataka o ličnosti je svaki podatak koji se odnosi na 
fizičko lice čiji je identitet određen ili odrediv, neposredno ili posredno, posebno na osnovu oznake 
identiteta, kao što je ime i identifikacioni broj, podatak o lokaciji, identifikator u elektronskim 
komunikacionim mrežama ili jednog, odnosno više obeležja njegovog fizičkog, fiziološkog, 
genetskog, mentalnog, ekonomskog, kulturnog i društvenog identiteta. Obrada podataka o ličnosti je 
svaka radnja ili skup radnji koje se vrše automatizovano ili neautomatizovano sa podacima o ličnosti 
ili njihovim skupovima, kao što su prikupljanje, beleženje, razvrstavanje, grupisanje, odnosno 
strukturisanje, pohranjivanje, upodobljavanje, menjanje, otkrivanje. </p>
          <p>Sva pitanja od značaja za zaštitu podataka o ličnosti, obradu istih kao i prava po tom osnovu 
savetujemo da posetite Politiku privatnosti.</p>
          <p>Partizanu je zabranjeno prodavanje, naručivanje, obezbeđivanje i/ili razmena podataka Kupca ili 
informacija o platnoj kartici u bilo kojoj formi trećem licu, osim ukoliko je to banka preko koje se vrši 
transakcija ili nadležni državni organi a na osnovu zakonskih ovlašćenja.</p>
          <p>Lični podaci Kupca koji se daju Partizanu prilikom registracije odnosno procesa kupovine smatraju se 
poslovnom tajnom. Ovi podaci takođe su regulisani Zakonom o zaštiti podataka o ličnosti.</p>
          <p>Partizan se obavezuje da od Kupca neće zahtevati i arhivirati u bilo kojoj elektronskoj formi, podatke 
vezane za platnu karticu kojom se transakcija realizuje a posebno broj kartice, datum isticanja, CVC2 
ili CVV broj, itd.</p>
          <p>Partizan obrađuje podatke o ličnosti Kupca u skladu sa važećim propisima kojima se uređuje zaštita 
podataka o ličnosti i svojom Politikom privatnosti. </p>
          <p>Informacije o vrstama podataka koji se obrađuju, svrhama i pravnom osnovu obrade, primaocima 
podataka, rokovima čuvanja, kao i pravima lica na koje se podaci odnose, dostupne su u Politici 
privatnosti, koja čini sastavni deo ovih Uslova korišćenja i dostupna je na internet sajtu Partizana.</p>
          <p>Korišćenjem internet sajta Partizana, Kupac potvrđuje da je upoznat sa Politikom privatnosti.</p>
          <p>Klikom na sledeći link možete videti <b>Politiku privatnosti</b></p>

          <br/>

          <h2>Kolačići (Cookies) </h2>
          <p>Partizan radi prodaje karata za sportske događaje koristi kolačiće (Cookies) i slične tehnologije radi 
obezbeđivanja pravilnog funkcionisanja, unapređenja korisničkog iskustva, analize korišćenja, 
očuvanja bezbednosti i sprečavanja zloupotreba, kao i u druge svrhe u skladu sa važećim propisima. </p>
          <p>Pojedini kolačići su neophodni za funkcionisanje internet sajta Partizana, dok se ostali koriste 
isključivo uz saglasnost Kupca, kada je takva saglasnost propisana važećim propisima Republike 
Srbije. </p>
          <p>Detaljnije informacije o vrstama kolačića, njihovoj svrsi, rokovima čuvanja i načinu upravljanja 
podešavanjima kolačića dostupne su u Politici privatnosti i dostupna je na internet sajtu Partizana. </p>
          <p>Klikom na sledeći link možete videti <b>Politiku privatnosti.</b></p>

          <br/>

          <h2>Plaćanje</h2>
          <p>Sve naknade, iznosi i ostala plaćanja navedena ili naplaćena putem internet sajta Partizana izražene su 
i plaćaju se u dinarima (RSD). Za informativni prikaz cena u drugim valutama koristi se kurs Narodne 
banke Srbije. </p>
          <p>Iznos za koji će biti zadužena platna kartica Kupca može biti izražen u lokalnoj valuti, u zavisnosti od 
konverzije koju vrši banka koja je izdala karticu, po kursu koji u trenutku transakcije nije poznat 
Partizanu. Kao rezultat ove konverzije postoji mogućnost za odstupanja između prikazane cene i one 
koja je na bankovnom računu Kupcu. </p>
          <p>Nakon završetka procesa kupovine, Partizan vrši ukupan obračun porudžbine, koji uključuje cenu 
ulaznica. </p>
          <p>Prilikom unošenja podataka o platnoj kartici, poverljive informacije se prenose putem javne mreže u 
zaštićenoj (kriptovanoj) formi upotrebom savremenih kriptografskih protokola. Obrada platnih 
podataka vrši se putem ovlašćenog procesora platnih usluga, pri čemu Partizan ni u jednom trenutku 
nema pristup niti čuva podatke o platnim karticama Kupca. </p>

          <br/>

          <h2>Vraćanje i zamena ulaznica</h2>
          <p>Povrat sredstava prethodno kupljenih ulaznica predstavlja diskreciono pravo Partizana. U slučaju 
prevelikog plaćanja ili drugih grešaka uzrokovanih samim servisom i kada se te greške potvrde, 
povraćaj sredstava može biti izvršen prema nahođenju Partizana. U tom slučaju, kontaktirajte Partizan 
putem e-mail-a  <a href="https://partizan.basketball/ ">https://partizan.basketball/</a>. </p>

          <br/>

          <h2>Povraćaj naplaćenih sredstava</h2>
          <p>U slučaju vraćanja robe i povraćaja sredstava kupcu koji je prethodno platio nekom od platnih kartica, 
delimično i/ili u celosti, a bez obzira na razlog vraćanja, Partizan je u obavezi da povraćaj vrši 
isključivo preko VISA, Maestro, MasterCard i DinaCard.  Skrećemo pažnju da Partizan ne prihvata 
plaćanja American Express karticama.</p>
          <p>U slučaju otkazivanja i/ili odlaganja događaja, odgovoran je Partizan. </p>

          <br/>

          <h2>Pravo na vraćanje ulaznica Kupac ulaznice ima samo u sledećim slučajevima:</h2>
          <p><ul>
            <li>otkazivanje događaja; </li>
            <li>odlaganje događaja na rok duži od 120 (sto dvadeset) dana od dana planiranog održavanja 
događaja; </li>
            <li>odlaganje događaja zbog nastupanja više sile koja traje duže od 180 (sto osamdeset) dana od 
dana planiranog održavanja događaja. </li>
          </ul></p>
          <p>Ukoliko se događaj otkazuje zbog razloga koji se mogu podvesti pod višu silu, odnosno iz razloga 
koji se nalaze van moći Partizana, Partizan će o tome obavestiti Kupca putem svog internet sajta, e
maila-a ili drugim raspoloživim sredstvima komunikacije. </p>
          <p>U slučaju postojanja više sile i otkazivanja događaja, bez njegovog prezakazivanja za nov termin, 
kupljene ulaznice prestaće da važe, a novac će biti vraćen Kupcu, u skladu sa prethodno utvrđenim 
pravilima Uslova korišćenja. U slučaju postojanja više sile i odlaganja događaja za nov termin, 
primenjivaće se pravila Uslova korišćenja koja se odnose na odlaganje događaja za nov termin. </p>
          <p>U svim ostalim slučajevima kupovine preko internet sajta Partizana, Kupac prihvatanjem Uslova 
korišćenja tokom procesa kupovine izričito izjavljuje da je obavešten da ne može da koristi pravo na 
odustanak od ugovora zaključenog na daljinu. </p>

          <br/>

          <h2>Dostava i isporuka </h2>
          <p>Partizan omogućava brzu i sigurnu dostavu ulaznica putem digitalnih kanala. Trenutno Partizan nudi 
sledeće opcije isporuke: </p>
          <p><ul>
            <li><b>E-TICKET (Print@home)</b>. PDF ulaznica sa aktivnim QR kodom će biti poslata na e-mail 
adresu koja je navedena prilikom kupovine na dan održavanja sportskog događaja. Ukoliko 
događaj to zahteva od Kupca, PDF odštampanu ulaznicu je obavezno poneti sa sobom na 
sportski događaj i pažljivo čuvati do događaja. </li>
            <li><b>M-TICKET (Mobilna ulaznica)</b>. Mobilna ulaznica sa aktivnim QR kodom (PDF prilagođen 
za prikaz na telefonu) biće poslata na e-mail adresu koju je Kupac naveo prilikom kupovine 
na dan odžavanja sportskog događaja. Preporučuje se da se ulaznica sačuva u svom telefonu i 
proveri baterija pre dolaska na sportski događaj. </li>
            <li><b>Digital Wallet (e-novčanik)</b>. Pored standardnih opcija, Partizan je omogućio i direktno 
dodavanje ulaznice u digitalni wallet na mobilnom telefonu na bazi NFC tehnologije. 
Digitalna ulaznica u mobilnom telefonu znači lakši pristup sportskom događaju bez potrebe 
za štampanjem i dodatnu sigurnost pri verifikaciji. Adekvatan aktivan QR kod se za svaki 
sportski događaj menja i aktivan QR kod na ulaznici u Digitalnom novčaniku se dobija na dan 
održavanja sportskog događaja. </li>
          </ul></p>
          <p>Bez obzira na način dostave, važno je da se ulaznice čuvaju na sigurnom mestu i da budu spremne 
prilikom dolaska na sportski događaj. </p>

          <br/>

          <h2>Zakonska odgovornost Partizana za saobraznost </h2>
          <p>U skladu sa Zakonom o zaštiti potrošača, Partizan odgovara za saobraznost u zakonskom roku. </p>
          <p>Usluga nije saobrazna ukoliko: </p>
          <p><ul>
            <li>po sadržini, kvalitetu i svrsi ne odgovara opisu koji je Partizan pre zaključenja ugovora dao 
oglasom i/ili na drugi sličan način;  </li>
            <li>ne odgovara opisu koji je Partizan dao u toku pružanja usluge pod uslovom da je to moglo da 
utiče na odluke Kupca;  </li>
            <li>nema posebna svojstva koja je zahtevao Kupac, a koja su Partizanu bila ili su morala biti 
poznata u trenutku zaključenja ugovora;  </li>
            <li>nema redovna svojstva usluga iste vrste;  </li>
            <li>ne odgovara očekivanjima koja su osnovana s obzirom na prirodu usluge i javna obećanja 
Partizana u pogledu posebnih svojstava usluge, a naročito ako su učinjena oglasom;  </li>
            <li>po sadržini, kvalitetu i svrsi ne odgovara opisu koji je pre zaključenja ugovora, oglasom ili na 
drugi sličan način dalo treće lice u ime Partizana.  </li>
          </ul></p>
          <p>Partizan nije odgovoran za nesaobraznost usluge ukoliko: </p>
          <p><ul>
            <li>nije znao ili nije morao da zna da je treće lice u njegovo ime dalo opis u njegovo ime;</li>
            <li>je sporni opis na odgovarajući način blagovremeno ispravljen. </li>
          </ul></p>
          <p>Ukoliko usluga nije saobrazna ugovorenoj, Kupac može da zahteva od Partizana da izvrši saobraznu 
uslugu.  </p>
          <p>Ukoliko je izvršenje saobrazne usluge nemoguće ili protivpravno, Kupac može zahtevati raskid 
ugovora. </p>
          <p>Ukoliko izvršenje saobrazne usluge predstavlja nesrazmerno opterećenje za Partizan, Kupac može 
zahtevati umanjenje cene ili raskid ugovora.  </p>
          <p>Ukoliko usluga nije saobrazna ugovorenoj, na prava Kupca i odgovornost Partizana shodno se 
primenjuju odredbe Zakona o zaštiti potrošača. </p>
          <p>Partizan je u obavezi da o isporučenoj robi odnosno uslugama obezbedi jasan i pouzdan dokaz da je 
roba odnosno usluge preuzeta od strane Kupca, odnosno ovlašćene osobe. U slučaju prodaje ulaznice 
za sportski događaj dokaz mora biti u formi dostavnice koja ima iste obavezujuće elemente kao i 
potvrda o plaćanju i to sledeće podatke:  </p>
          <p><ul>
            <li>ime i prezime Kupca odnosno ovlašćenog lica koje je preuzelo robu odnosno usluge; </li>
            <li>podatke o Partizanu; </li>
            <li>podatke o transakciji; </li>
            <li>datum isporuke.</li>
          </ul></p>
          <p>U slučaju da se radi o nematerijalnim dobrima ili uslugama koje se isporučuju elektronskim putem 
dokaz može biti u formi elektronskih poruka i logova sa servera. Partizan je u obavezi da u periodu od 
2 (dve) godine od momenta nastanka transakcije, na bezbedan i siguran način arhivira sve dokaze 
opisane u prethodnom stavu, kao i da ih dostavi na zahtev banke preko koje se vrši transakcija u 
slučaju reklamacije transakcije. </p>

          <br/>

          <h2>Intelektualna svojina </h2>
          <p>Internet sajt Partizana, platforma i njen softver, dizajn, tekstovi, grafički elementi, žigovi, zaštitni 
znakovi, logotipi, baze podataka i drugi sadržaji predstavljaju intelektualnu svojinu Partizana. </p>
          <p>Kupcu se kupovinom karte za sportski događaj ne prenosi niti ustupa bilo koje pravo intelektualne 
svojine Partizana. </p>
          <p>Bez prethodne pisane saglasnosti Partizana nije dozvoljeno kopiranje, umnožavanje, menjanje, 
distribuiranje, javno saopštavanje ili drugo korišćenje sadržaja, osim u meri u kojoj je to dozvoljeno 
važećim propisima Republike Srbije.</p>

          <br/>

          <h2>Rešavanje sporova </h2>
          <p>Ugovorne strane su saglasne da sve eventualne nesporazume i sporna pitanja koja nastanu tokom 
trajanja ugovornog odnosa nastojati da reše mirnim putem. U slučaju da izostane mirno rešenje 
nesporazuma i spornih pitanja ugovara se nadležnost stvarno nadležnog suda u Beogradu, a 
primenjuje se pravo Republike Srbije. </p>

          <br/>

          <h2>Vansudsko rešavanje sporova </h2>
          <p>U skladu sa Zakonom o zaštiti potrošača, Kupac može spor da reši i u postupku vansudskog rešavanja 
spora. </p>

          <br/>

          <h2>Reklamacije </h2>
          <p>Kupac može da izjavi reklamaciju radi ostvarivanja svojih prava iz Zakona o zaštiti potrošača, kao i 
zbog pogrešno obračunate cene i drugih nedostataka, usmeno na prodajnom mestu gde je ulaznica 
kupljena ili na sledeći način: </p>
          <p><ul>
            <li>elektronskim putem na e-mail adresu <a href="mailto:tickets@partizan.basketball">tickets@partizan.basketball</a></li>
            <li>poštom na adresu sedišta Partizana.</li>
          </ul></p>
          <p>Prilikom izjave reklamacije, Kupac je dužan da dostavi račun kao dokaz o kupovini. </p>

          <br/>

          <h2>Završne odredbe </h2>
          <p>Uslovi korišćenja javno su objavljeni dana 21.08.2026. godine od kog dana se i primenjuju u 
potpunosti. Izmena Uslova korišćenja vršiće se u skladu sa izmenama pravila postupanja i 
funkcionisanja internet stranice kao i u drugim slučajevima koje Partizan po svojoj apsolutnoj 
diskreciji utvrdi.</p>
          <p>Ukoliko bilo koji uslov i/ili odredba sadržana u ovim Uslovima korišćenja postane nepunovažna, to 
neće uticati na punovažnost ostalih odredbi koje nisu pogođene nepunovažnošću.</p>
          <p>Kupac je dužan da prati Uslove korišćenja i izmene istih, imajući u vidu da su javno dostupni na 
internet sajtu Partizana, kao i da je u interesu Kupca da bude upoznat sa istima. </p>
`,
        footer: `
          <li className="sell-footer__contacts-item">Basketball Club Partizan</li>
          <li className="sell-footer__contacts-item">MB: 07051026</li>
          <li className="sell-footer__contacts-item">Humska 1</li>
          <li className="sell-footer__contacts-item">PIB: 101368803</li>
          <li className="sell-footer__contacts-item">11 000 Beograd</li>
          <li className="sell-footer__contacts-item">
            <a
              href="mailto:tickets@partizan.basketball"
              rel="noopener noreferrer"
              target="_blank"
              style="color: ${colorsTheme && colorsTheme.primaryColor}"
            >
              tickets@partizan.basketball
            </a>
          </li>
          <li className="sell-footer__contacts-item">
            +381 66 8551 011
          </li>
          <li className="sell-footer__contacts-item">
            <a
              href="https://partizan.basketball/"
              rel="noopener noreferrer"
              target="_blank"
              style="color: ${colorsTheme && colorsTheme.primaryColor}"
            >
              partizan.basketball
            </a>
          </li>
        `,
        termsLink: 'https://app.partizan.basketball/partizan/terms.pdf',
        policyLink: 'https://app.partizan.basketball/partizan/politika_privatnosti.pdf',
      };

    case "france":
      return {
        ...defaultData,
        theme: "france",
        title: "Fancee",
        defaultTimeZone: "Europe/Paris",
        currency: "EUR",
        terms: `
          <p className="terms-title" style="text-align: center">INFORMATIONS LEGALES</p>
          <p style="margin-left:0px;">
            Conformément aux dispositions des articles 6-III et 19 de la loi pour la Confiance dans l'Économie Numérique, nous vous informons que:&nbsp;
          </p>
          <p style="margin-left:0px;">
            Le présent site internet, www.france.fr (ci-après désigné le «Site ») est édité par :&nbsp;
          </p>
          <p style="margin-left:0px;">
            Le GIE Atout France,&nbsp;<br>dont le siège social est situé au 200/216 rue Raymond Losserand - CS 60043 - 75680 PARIS Cedex 14&nbsp;<br>Tél. : +33 1 42 96 70 00&nbsp;<br>RCS de Paris 340 709 211&nbsp;<br>Numéro de TVA intracommunautaire : FR 39340709211&nbsp;
          </p>
          <p style="margin-left:0px;">
            Adresse de courrier électronique : legal@atout-france.fr.&nbsp;
          </p>
          <p style="margin-left:0px;">
            La directrice de la publication du Site est la Directrice Générale de Atout France, Mme Rose-Marie Abel.
          </p>
          <p style="margin-left:0px;">
            Le Site est hébergé par :&nbsp;
            <br>
            <br>
            SCALEWAY
            <br>
            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);">
              dont le siège social est situé au 11bis rue Roquépine, 75008 Paris
            </span>
            <br>
            Tél. : &nbsp;01 53 77 61 77
            <br>
            <br>
            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);">
              <strong>Propriété intellectuelle&nbsp;</strong>
            </span>
            <br>
            L'ensemble de ce Site relève de la législation française notamment en matière de propriété intellectuelle et de données personnelles ainsi que de la législation internationale.&nbsp;
          </p>
          <p style="margin-left:0px;">
            Les informations, pictogrammes, iconogrammes, photographies, images, textes, séquences vidéo, animées sonores ou non, et autres éléments présents sur le Site sont protégés par des droits de propriété industrielle et/ou intellectuelle dont Atout France, est soit titulaire, soit autorisé à les reproduire et les représenter.&nbsp;
          </p>
          <p style="margin-left:0px;">
            A ce titre, toute reproduction, représentation, adaptation, traduction et/ou modification, partielle ou intégrale ou transfert par quelque procédé que ce soit, est interdite sans autorisation expresse, préalable et écrite de Atout France. Cet acte constituerait une contrefaçon au sens des articles L.335-2 et suivants du Code de la Propriété intellectuelle.&nbsp;
          </p>
          <p style="margin-left:0px;">
            La copie sur support papier à usage privé de ces différents objets de droits est autorisée conformément à l’article L122-5 du Code de la Propriété Intellectuelle.&nbsp;
          </p>
          <p style="margin-left:0px;">
            Pour toute utilisation ou renseignement à ce sujet, veuillez nous contacter en vous adressant à :&nbsp;
          </p>
          <p style="margin-left:0px;">
            Atout France, Secrétariat Général,&nbsp;
          </p>
          <p style="margin-left:0px;">
            200/216 rue Raymond Losserand - CS 60043 - 75680 PARIS Cedex 14&nbsp;
          </p>
          <p style="margin-left:0px;">
            ou en ligne à l'adresse suivante : legal@atout-france.fr.&nbsp;
          </p>
          <p style="margin-left:0px;">
            Les marques de Atout France et de ses partenaires, ainsi que les logos cités et reproduits sur ce Site sont des marques déposées.&nbsp;
          </p>
          <p style="margin-left:0px;">
            Toute reproduction totale ou partielle de ces marques ou de ces logos effectués à partir des éléments du Site sans l'autorisation expresse et préalable de Atout France est prohibée au sens du Code de la Propriété intellectuelle.&nbsp;
          </p>
          <p style="margin-left:0px;">
            Atout France ne saurait être responsable de l'accès par les internautes via les liens hypertextes mis en place dans le cadre du Site en direction d'autres ressources présentes sur le réseau.&nbsp;
          </p>
          <p style="margin-left:0px;">
            <strong>Protection des données personnelles&nbsp;</strong>
          </p>
          <p style="margin-left:0px;">
            Le respect de la protection des données à caractère personnel est un élément déterminant de la relation de confiance que nous souhaitons établir avec vous.&nbsp;
          </p>
          <p style="margin-left:0px;">
            Que vous soyez visiteur, partenaire, adhérent, client, lecteur ou prospect, usager d’une des missions de service public administratif, professionnel ou particulier, Atout France collecte et traite vos données à caractère personnel pour :&nbsp;
          </p>
          <p style="margin-left:0px;">
            vous informer sur nos événements et ceux de nos partenaires et vous permettre d’y participer ;&nbsp;
          </p>
          <p style="margin-left:0px;">
            vous adresser nos communications (newsletter, catalogues, etc.) ;&nbsp;
          </p>
          <p style="margin-left:0px;">
            vous proposer nos produits et nos services ou vous faire connaitre ceux de nos partenaires;&nbsp;
          </p>
          <p style="margin-left:0px;">
            vous permettre d’accéder à notre site internet et de participer à nos jeux concours ;&nbsp;
          </p>
          <p style="margin-left:0px;">
            nous permettre de faire des analyses et des études relatives à nos produits et services et à la fréquentation de nos sites internet ;&nbsp;
          </p>
          <p style="margin-left:0px;">
            nous permettre de réaliser les missions qui nous sont confiées.&nbsp;
          </p>
          <p style="margin-left:0px;">
            Des données indirectement personnelles, à usage statistique, peuvent également être collectées à des fins de gestion de votre connexion et de votre navigation. Vous pouvez consulter notre politique sur les cookies en suivant le lien ci-dessous :&nbsp;
          </p>
          <p style="margin-left:0px;">
            <a href="https://www.france.fr/fr/page/informations-legales">
              <span style="color:rgb(0,0,255);">
                https://www.france.fr/fr/page/informations-legales
              </span>
            </a>&nbsp;
          </p>
          <p style="margin-left:0px;">
            Nous ne mettons en œuvre des traitements de données que lorsque l’une des conditions suivantes est remplie :&nbsp;
          </p>
          <p style="margin-left:0px;">
            votre consentement aux opérations de traitement a été recueilli ;&nbsp;
          </p>
          <p style="margin-left:0px;">
            l’existence de notre intérêt légitime, ou de celui d’un tiers, qui justifie que nous mettions en œuvre le traitement de données à caractère personnel concerné ;&nbsp;
          </p>
          <p style="margin-left:0px;">
            l’exécution d’un contrat qui nous lie à vous nécessite que nous mettions en œuvre le traitement de données à caractère personnel concerné ;&nbsp;
          </p>
          <p style="margin-left:0px;">
            nous sommes tenus par des obligations légales et réglementaires qui nécessitent la mise en œuvre du traitement de données à caractère personnel concerné.&nbsp;
          </p>
          <p style="margin-left:0px;">
            Dans l’hypothèse où nous sollicitons votre consentement, celui-ci est collecté directement sur le formulaire prévu pour procéder à la collecte des informations qui vous concerne.&nbsp;
          </p>
          <p style="margin-left:0px;">
            <strong>Comment exercer vos droits&nbsp;</strong>
          </p>
          <p style="margin-left:0px;">
            Vous pouvez exercer vos droits (demande d’accès, de rectification, d’oubli, d’effacement, d’opposition ou de portabilité, plus de précisions sous 
            <a href="https://assets.france.fr/int/legal/general/ATF-formulaire-de-demande-d-exercice-des-droits-des-personnes-concernees.pdf" target="_blank" rel="noopener noreferrer">
              ce lien
            </a>
             par voie électronique à l’adresse suivante : contact.rgpd@atout-france.fr, ou par courrier postal à l’adresse suivante : Atout France, Service juridique, 200/216 rue Raymond Losserand - CS 60043 - 75680 PARIS Cedex 14 en justifiant de votre identité.&nbsp;
          </p>
          <p style="margin-left:0px;">
            Vous pouvez introduire une réclamation auprès d’une autorité de contrôle – En France, il s’agit de la CNIL, 3 place de Fontenoy, TSA 80715, 75334 Paris cedex 07.&nbsp;
          </p>
          <p style="margin-left:0px;">
            Vous avez la possibilité de définir des directives relatives à la conservation, à l’effacement et à la communication de vos données personnelles après votre décès et ce auprès d’un tiers de confiance, certifié et chargé de faire respecter la volonté du défunt, conformément aux exigences du cadre juridique applicable.&nbsp;
          </p>
          <p style="margin-left:0px;">
            <strong>Mentions d’informations détaillées&nbsp;</strong>
          </p>
          <p style="margin-left:0px;">
            Vous trouverez plus d’informations sur le traitement de vos données personnelles et sur vos droits en cliquant sur le lien suivant :&nbsp;
          </p>
          <p style="margin-left:0px;">
            Vous êtes un usager de service public administratif : vos mentions d’informations sous 
            <a href="https://assets.france.fr/int/legal/admin/Mentions_informations-Atout-France-Usagers-service-public.pdf" target="_blank" rel="noopener noreferrer">
              <span style="color:rgb(0,0,255);">ce lien</span>
            </a> ;&nbsp;
          </p>
          <p style="margin-left:0px;">
            Vous êtes un partenaire-client-prospect de Atout France : vos mentions d’informations sous 
            <a href="https://assets.france.fr/int/legal/partenaires/NOTICE-D-INFORMATION-POUR-LES-PARTENAIRES-CLIENTS-OU-PROSPECTS.pdf" target="_blank" rel="noopener noreferrer">
              ce lien
            </a>.&nbsp;
          </p>
          <p style="margin-left:0px;">
            Vous pouvez également nous contacter à l’adresse suivante :&nbsp;
          </p>
          <p style="margin-left:0px;">
            contact.rgpd@atout-france.fr ou par courrier postal à Atout France - Service Juridique – 200/216 rue Raymond Losserand - CS 60043 - 75680 PARIS Cedex 14 – France, Votre demande d’exercice de droits devra être accompagnée d’une copie d’un titre d’identité signé afin de nous permettre de vérifier votre identité.&nbsp;
          </p>
          <p style="margin-left:0px;">
            <strong>Limitation de responsabilité&nbsp;</strong>
          </p>
          <p style="margin-left:0px;">
            Atout France ne saurait être tenue pour responsable des erreurs matérielles qui se seraient glissées dans les documents présents sur le Site, malgré tout le soin apporté à leur publication.&nbsp;
          </p>
          <p style="margin-left:0px;">
            Les informations fournies sur le Site le sont à titre indicatif et ne sauraient dispenser l'internaute d'une analyse complémentaire et personnalisée.&nbsp;
          </p>
          <p style="margin-left:0px;">
            Atout France ne saurait non plus être tenue pour responsable des informations, propos et opinions émises sur les sites vers lesquels elle pointe par des liens hypertexte et dont elle n'a pas la maîtrise éditoriale.&nbsp;
          </p>
          <p style="margin-left:0px;">
            Les sites qui font le choix de pointer vers france.fr (<a href="https://www.france.fr/"><span style="color:rgb(0,0,255);">https://www.france.fr</span></a>) engagent leur responsabilité dès lors qu’ils porteraient atteinte à l’image du Site.&nbsp;
          </p>
          <p style="margin-left:0px;">
            Atout France ne peut pas plus être tenue pour responsable de la transmission défectueuse des données dues aux divers réseaux de l’Internet ou aux incompatibilités dues au navigateur de l’internaute.&nbsp;
          </p>
          <p style="margin-left:0px;">
            Tout litige en relation avec l'utilisation du Site est soumis au droit français. L'internaute reconnaît la compétence exclusive des tribunaux compétents du ressort de la Cour d’appel de Paris.&nbsp;<br>&nbsp;
          </p>
        `
      }

    default:
      localStorage.setItem("region", "sixtix"); // dev feature

      return {
        ...defaultData
      }
  }
}

function getDefinedRegion() {
  const host = window.location.host;

  switch (host) {
    case "localhost:3000":
    case "dev-app.sixtix.com":
    case "app.sixtix.com":
      return "sixtix";

    case "dev-app.fanceetickets.com":
    case "app.fanceetickets.com":
      return "sixtix";
      // return "fanceetickets";

    case "dev-app.headworks.com.ua":
    case "app.headworks.com.ua":
    case "dev-app.france.fr":
    case "app.france.fr":
      return "france";

    case "app.partizan.basketball":
    case "dev-app.partizan.basketball":
      return "sixtix";

    default:
      break;
  }
}